<it-table striped="true" *ngIf="ownRequest?.length">
    <ng-container thead>
      <tr>
        <th scope="col">Data cambio competenza</th>
        <th scope="col">N Pratica</th>
        <th scope="col">Paziente</th>
        <th scope="col">Setting</th>
        <th scope="col">Entità segnalante</th>
        <th scope="col">Entità mittente</th>
        <th scope="col">Stato</th>
        <th scope="col" class="text-center">Notifiche</th>
        <th scope="col">Dettaglio</th>
      </tr>
    </ng-container>
  
    <ng-container tbody>
      <tr *ngFor="let request of ownRequest">
        <td>{{ request.ownership.changeDate | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>{{ request.code }}</td>
        <td>{{ request.patient.name }} {{ request.patient.surname }}</td>
        <td>{{ request.setting.name }}</td>
        <td>{{ request.creator?.name }}</td>
        <td>{{ request.sender?.name }}</td>
        <td>
          <span [itBadge]="getBadgeColor(request.status.code)" [rounded]="'true'"
          class="d-inline-block w-100 text-center">
            {{ request.status.name }}
          </span>
        </td>
        <td class="text-center">{{ request.notificationToReadNumber }}/{{ request.notificationNumber }}</td>
        <td class="p-0 text-center">
          <a [routerLink]="['/detail/' + request.uuid]" class="d-block px-2 py-2 text-decoration-none">
            <it-icon name="file" size="sm" color="primary"></it-icon>
          </a>
        </td>
      </tr>
    </ng-container>
  </it-table>